import React, { memo } from 'react';

import Button from '../../helpers/Button';

import style from './style.module.css';

const EmailFinderFieldComponent = ({ onFindEmail, children }) => (
  <div className={style.host}>
    <div className={style.email}>{children}</div>
    <Button className="btn-primary" onClick={onFindEmail}>
      Finder
    </Button>
  </div>
);

/** Email input (children) with the Finder button next to it. */
export const EmailFinderField = memo(EmailFinderFieldComponent);
